import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { AuthFacade } from '@piqet-angular/data';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RestrictDefaultPasswordChangeGuard implements CanActivate {
  isPasswordChangeEnable: boolean = false;

  constructor(
    private router: Router,
    public authFacade: AuthFacade,
    private cookieService: CookieService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    this.isPasswordChangeEnable = this.cookieService.get('forceResetPasswordDisable') === 'false';
    if (!this.isPasswordChangeEnable) {
      this.router.navigate(['/login']);
      return false;
    }
    return true;
  }
}
